export const API_URL = 'https://neonsportz.com/api/leagues/RFL23/';
